import React from 'react';
import classnames from 'classnames';
import { Body1, Body2, Caption } from '@xo-union/tk-ui-typography';
import Icon from '@xo-union/tk-component-icons';

import styles from './InfoCard.scss';
import useShareTracking from '../SharePage/useShareTracking';

interface InfoCardProps {
  title: React.ReactNode;
  content: React.ReactNode;
  onClick: (track: ReturnType<typeof useShareTracking>) => void;
  className?: string;
  dataTestid?: string;
  ariaLabel?: string;
  footer?: React.ReactNode;
}

export const InfoCard = ({ title, content, onClick, className, dataTestid, ariaLabel, footer }: InfoCardProps) => {
  className = classnames(styles.infoCard, styles[className || '']);
  const track = useShareTracking();

  return (
    <button
      className={className}
      role="link"
      onClick={() => onClick(track)}
      data-testid={dataTestid}
      aria-label={ariaLabel}
    >
      <div>
        <Body1 bold>{title}</Body1>
        <Body2>{content}</Body2>
        <Caption>{footer}</Caption>
      </div>
      <Icon name="arrow_right_2" className={styles.infoCardIcon} size="lg" />
    </button>
  );
};

export default InfoCard;
